import { KycDialogOpen } from 'features/prop/interfaces';
import {
    PropChallenge,
    GetChallengeValidateWithdrawalResponse,
    TradingPlatformAccountInfo,
    PropPlan,
    AdditionalInfo,
    KeeperDetail,
    PlanDetails,
} from 'services/generatedClientFromSwagger';

export type PlanOrKeeper = PropPlan | KeeperDetailWithType;

export class KeeperDetailWithType extends KeeperDetail {
    isKeeperPurchase: boolean = true;
    keeperTypes: KeeperType[];
    challengeId?: string;
    packageName?: string;
    amount?: number;
    propChallenges?: Array<PropChallenge>;
    pPlan?: PlanDetails;
    originalAdditionalInfo?: AdditionalInfo;
}
export const isKeeperGuard = (plan: PlanOrKeeper): plan is KeeperDetailWithType => {
    return 'isKeeperPurchase' in plan;
};

export interface PropMyPlansReducerState {
    challengesLoader: boolean | undefined;
    isPlansLoading: boolean;
    plans: Array<PropPlan>;
    myPurchases: Array<PlanOrKeeper>;
    challenges: Array<PropChallenge>;
    filteredChallenges: Array<PropChallenge>;
    onlyFundedChallenges: Array<PropChallenge>;
    fundedPropChallenge: Array<PropChallenge>;
    challengeIframeLoading: boolean;
    challengeIframe: Array<{ [tpId: string]: string }>;
    challengeIframeError: string | undefined;
    selectedChallenge: PropChallenge | undefined;
    selectedChallengePlan: PropPlan | undefined;
    mainAccountTp: TradingPlatformAccountInfo | undefined;
    challengeIframePopup: boolean;
    setFundedChallengeLoader: boolean;
    fundsFilterOptions: Array<number>;
    validateWithdrawalData?: Record<string, GetChallengeValidateWithdrawalResponse>;
    isKycDialogOpen: KycDialogOpen;
    manualKycLoading?: boolean;
    isStartFundedAlertOpen: { [challengeId: string]: { display: boolean; sent: string } };
    additionalInfoFromMonetaryTransactions: Array<AdditionalInfo>;
    takenRetries: Record<string, boolean>;
    openKeepAlertPopupState?: KeepChallengePopupState;
    openKeepPurchasePopupState?: KeepPurchasePopupState;
    keeperModalsOpened: Record<string, Record<KeeperType, boolean>>;
    openKeepBannerPopupState?: KeepChallengePopupState;
}

export enum KeeperType {
    MAX_TOTAL = 'maxTotal',
    MAX_DAILY = 'maxDaily',
}

export interface KeepChallengePopupState {
    isOpen?: boolean;
    selectedChallenge?: PropChallenge;
    selectedChallengePlan?: PropPlan;
}

export interface KeepPurchasePopupState extends KeepChallengePopupState {
    type?: KeepModalType;
}

export const DONT_LET_YOUR_CHALLENGE_END = 'dont_let_your_challenge_end';

export enum KeepModalType {
    ACTIVATING_CHALLENGE_KEEPER = 'activating_challenge_keeper',
    CHALLENGE_KEEPER_ACTIVATED = 'challenge_keeper_activated',
    SOMETHING_WENT_WRONG = 'something_went_wrong',
    CHALLENGE_KEEPER_EXPIRED = 'challenge_keeper_expired',
    FAILED_PSP = 'failed_psp',
}
